import React from "react";
import styled from "styled-components";
import { AiFillLinkedin, AiFillGithub } from "react-icons/ai";
import {useSelector } from "react-redux"

const PortfolioHeader = () => {
  const reduxProfile = useSelector((store)=> store.port.profile)
  return (
    <Wrapper>
        {
          reduxProfile !== "" && 
          <div className="header-container">
          <div className="profile-pic">
            <img src="../profile.png" />
          </div>
        
          <div className="profile-detail">
            <h1 className="name">{reduxProfile[0].name}</h1>
            <p className="designation">{reduxProfile[0].designation}</p>
            <div className="table">
            <p className="title">Name:</p>
              <p className="value" >{reduxProfile[0].name}</p>
              {/* <p className="title">Age</p>
              <p className="value">{reduxProfile[0].age}</p> */}
              <p className="title">Phone:</p>
              <p className="value">{reduxProfile[0].phone}</p>
              <p className="title">Email:</p>
              <p className="value">{reduxProfile[0].email}</p>
            </div>
            <div className="social-container">
              <a href={reduxProfile[0].linkedin} target="_blank">
                <AiFillLinkedin
                  className="linked-icon"
                  onMouseOver={({ target }) => (target.style.opacity = 1)}
                  onMouseLeave={(target) =>(target.style.opacity = 1)}
                  name="AiFillLinkedin"
                  size={24}
                  color={"white"}
                  opacity={1}
                />
              </a>
              <a href={reduxProfile[0].github} target="_blank">
                <AiFillGithub
                  name="AiFillGithub"
                  size={24}
                  color={"white"}
                  opacity={1}
                />
              </a>
            </div>
          </div>
          <a
            href={reduxProfile[0].resume} 
            target="_blank"
          >
            {" "}
            <button className="cv-btn">Download CV</button>
          </a>
        </div>
        }
     
    </Wrapper>
  );
};

const Wrapper = styled.section`
/* background-image: linear-gradient(to bottom, #051937, #0f1f4d, #232361, #3d2473, #5b2082, #713392, #8647a3, #9c5ab4, #ae85cc, #c4aee0, #dfd7f1, #ffffff); */
background-color: #FF3CAC;
background-image: linear-gradient(225deg, #FF3CAC 0%, #784BA0 50%, #2B86C5 100%);






  h1,
  p {
    color: white;
    margin: 0.3rem 0;
  
  }
  .value{
    font-size: small;
  }
  .title{
    /* font-weight: bold; */
    font-size: medium;
  }
  .table{
    margin-top: 1rem;
  }
  .name{
    color: white;
    font-size: xx-large;
  }
  .designation{
    color: white;
    font-size: medium;
  }

  .header-container {
    display: grid;
    grid-template-columns: 22% 60% 5%;
    width: 80%;
    margin: auto;
    /* border: 2px solid black; */
    gap: 2rem;
    padding: 1rem;

    /* background-color: red; */
  }
  img {
    border-radius: 33rem;
    /* border: 1px solid white; */
      box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
  }

  .profile-pic {
  }
  .profile-detail {
    /* background-color: yellow; */
    padding: 0.5rem;
  }
  .cv-btn {
    background-color: white;
    border-radius: 3rem;
    width: 8rem;
    /* height: 3rem; */
    color: #D40B7E;
    border: 0px solid white;
    padding: 0.6rem;
    margin: 1rem;
  }
  .table {
    display: grid;
    grid-template-columns: 30% 80%;
    /* background-color: aqua;s */
    /* grid-gap: 1rem ; */

    /* background-color: red; */
  }
  .social-container {
    width: 4rem;
    /* background-color: aqua; */
    display: flex;
    justify-content: space-between;
  }

  @media (max-width: 500px) {
    .header-container {
      display: flex;
      flex-direction: column;
    }
    .profile-pic {
      display: flex;
      /* background-color: red; */
      justify-content: center;
    }
    img {
      height: auto;
      width: 50%;
    }
    .cv-btn {
      margin: 0;
    }
  }
`;

export default PortfolioHeader;
